import { Paper } from '@material-ui/core'
import React from 'react'
import { Subscribe } from 'unstated'
import CourseStore from '../../../../../../../Store/CourseStore'
import { Link } from 'react-router-dom'
import {  darkAccent } from '../../../../../../../../../Styles/colors'

const LinkedQnaBanner = () => {


  return (
    <Subscribe to={[CourseStore]}>
        {({
            state:{
                teacher,
                livDemyID,
                upcomingQna =[]
            }
        })=><>
        {
            upcomingQna.map((qna, index) => (
                <Paper 
                key={qna.url}
                style={{
                    alignItems: 'center',
                    padding: 10,
                    margin: `1em 2em 0em`,
                    background: '#C7402D linear-gradient(196.67deg, #EC9770 0%, #EC9770 50%, #F9C7B8 100%)',
                    color: '#333',
                    fontSize: 14,
                    fontWeight: 500,
                    borderRadius: 5,
                    textAlign: 'center',
                }}>
                    {`Sign up for the upcoming Live, interactive Q&A Session with ${teacher?.name}. Free for Certification course students. `}
                    {`Click here to`}&nbsp;<Link to={`/${livDemyID}/qna/${qna.url}`} style={{color:darkAccent,display:'inline-block'}}>register.</Link> 
                </Paper>
            ))
        }
        </>}

        </Subscribe>
  )
}

export default LinkedQnaBanner